import React from 'react'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {useBankAccounts} from '../../hooks'
import {BankAccountForm} from '../BankAccountForm'
import {Step9Props} from '../../types'

const Step9: React.FC<Step9Props> = ({
  setActiveStep,
  eKYCRes,
  handleGetListBank,
  handleGetListBankBr,
  setFieldValue,
}) => {
  const {
    selectedOptions,
    valueListBank,
    valueListBranch,
    removeButtons,
    isLoadingBanks,
    loadingBranches,
    DEFAULT_BANK_OPTION,
    DEFAULT_BRANCH_OPTION,
    MAX_BANK_ACCOUNTS,
    handleSelectChange,
    handleAddBank,
    handleRemoveBank,
  } = useBankAccounts({
    setActiveStep,
    handleGetListBank,
    handleGetListBankBr,
    setFieldValue,
  })

  const getAccountOwnerName = (): string => {
    return eKYCRes?.ocr?.object?.name || 'Nguyen Van A'
  }

  return (
    <div className='w-100'>
      {selectedOptions.map((_, index) => (
        <BankAccountForm
          key={index}
          index={index}
          bankList={valueListBank}
          branchList={valueListBranch[index] || []}
          showRemoveButton={removeButtons[index]}
          canRemove={selectedOptions.length > 1}
          accountOwnerName={getAccountOwnerName()}
          defaultBankOption={DEFAULT_BANK_OPTION}
          defaultBranchOption={DEFAULT_BRANCH_OPTION}
          isLoadingBanks={isLoadingBanks}
          isLoadingBranches={loadingBranches.has(index)}
          onSelectChange={handleSelectChange}
          onRemove={handleRemoveBank}
        />
      ))}

      {selectedOptions.length < MAX_BANK_ACCOUNTS && (
        <div className='mt-6'>
          <button
            className='d-flex align-items-center bg-transparent border-0'
            onClick={handleAddBank}
            disabled={selectedOptions.length >= MAX_BANK_ACCOUNTS}
            type='button'
          >
            <img
              className=''
              alt='Add bank account'
              src={toAbsoluteUrl('/media/nhsv/add-circle.png')}
            />
            <div className='fw-bolder text-primary mx-2'>Thêm tài khoản ngân hàng</div>
          </button>
        </div>
      )}
    </div>
  )
}

export {Step9}
